import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment, pluralize} from '@api'
import { MenuItem } from '@blueprintjs/core'
import {ContextMenuItem, useVipLocalStore, VipLocalStore} from '@modules'
import {CloudPDFEntry} from '@modules/pdf'
import {icons, StoresInstance, ui} from '@stores'
import {PrimaryIconButton, SearchField2} from 'centric-ui-components'
import {ChangeEvent} from 'react'
import * as css from './PDFTabMenuItems.css'

/// region Store

export class PDFTabMenuItemsStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable searchText = ''
  @action onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    this.searchText = e.target.value ?? ''
  }

  @action clearSearch = () => { this.searchText = ''}

  @action openPDF = (entry: CloudPDFEntry) => (e) => {
    const {stores: {cloudPDF: {component}}} = this
    component.selectedPdf = entry
  }
}

export const PDFTabMenuItemsStoreContext = React.createContext<PDFTabMenuItemsStore>(null)
export const usePDFTabMenuItemsStore = () => React.useContext(PDFTabMenuItemsStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const PDFTabMenuItems = observer<MyProps>(function PDFTabMenuItems({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new PDFTabMenuItemsStore(stores, obsProps)),
    {searchText, onChangeSearch, clearSearch, cloudPDF: {pdfByTemplate, templatesById}, stores, strings, openPDF} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <PDFTabMenuItemsStoreContext.Provider value={store}>
      <ContextMenuItem dividerAfter icon='folder-open' text='Open PDF...'
                       className={css.openPdfMenuItem}
                       popoverProps={{className: css.openPdfPopover, ...MenuItem.defaultProps.popoverProps}}>
        <div className={css.toolbar}>
          <SearchField2 className={css.search}
                        value={searchText}
                        type='text'
                        inputProps={{size: 12}}
                        active
                        placeholder={'Search...'}
                        onSearch={onChangeSearch}
          />

          <PrimaryIconButton icon={icons.clear}
                             tooltip='Clear' onClick={clearSearch}
                             tooltipPosition='bottom'
          />
        </div>

        <ContextMenuItem icon='blank' text='By Template...'>
          {_.keys(pdfByTemplate).map(k => {
            const pdfs = pdfByTemplate[k],
              templateFactory = templatesById[k],
              template = templateFactory ? templatesById[k](stores) : null;

            return <ContextMenuItem icon={'blank'} key={k} text={template?.text ?? k ?? strings.noValue}>
              {pdfs.map(v => <MenuItem key={v.entry._id}
                                       text={v.label}
                                       label={`${v.entry.pages} ${pluralize('page', v.entry.pages)}`}
                                       onClick={openPDF(v)}
              />)}
            </ContextMenuItem>
          })}
        </ContextMenuItem>
        <ContextMenuItem icon='blank' text='Recently Opened...'>
          <ContextMenuItem text='foo'/>
        </ContextMenuItem>
        <ContextMenuItem icon='blank' text='By Keyword...'>
          <ContextMenuItem text='foo'/>
        </ContextMenuItem>
        {/**
         Search bar
         Recent
         By Template
         By distinct keywords
         **/}
      </ContextMenuItem>
    </PDFTabMenuItemsStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/PDFTabMenuItems.tsx